import { getCategoryId } from './SkuMenuData.normalizers';

const toSortedUniqueIds = ids =>
  Array.from(new Set((ids || []).filter(Boolean).map(String))).sort((a, b) => a.localeCompare(b));

export const runSequentially = (entries, operation) =>
  entries.reduce((promise, entry) => promise.then(() => operation(entry)), Promise.resolve());

export const getCategoryRelationDelta = ({ previousCategoryIds = [], nextCategories = [] }) => {
  const previousIds = toSortedUniqueIds(previousCategoryIds);
  const nextIds = toSortedUniqueIds(nextCategories.map(getCategoryId));

  const previousSet = new Set(previousIds);
  const nextSet = new Set(nextIds);

  const removedCategoryIds = previousIds.filter(id => !nextSet.has(id));
  const addedCategoryIds = nextIds.filter(id => !previousSet.has(id));

  return {
    removedCategoryIds,
    addedCategoryIds,
    nextCategoryIds: nextIds,
  };
};
